import React, { useEffect } from "react";
import * as CONFIG from "../pages/_config";
import { Link } from "react-router-dom";

function DeleteAccount() {
  // console.log(CONFIG.DATA.DELETE_USER_PAGE_INFORMATION);
  // console.log(CONFIG.DATA.DELETE_USER_PAGE_TITLE);

  return (
    <div>
      <div className="main-container full-width pt-2 mt-2">
        {CONFIG.DATA.THEME === 2 ? (
          <div>
            <section
              id="apus-breadscrumb"
              className="breadcrumb-page apus-breadscrumb"
              style={{ backgroundColor: "#f3ffd9" }}
            >
              <div className="container">
                <div className="wrapper-breads">
                  <div className="wrapper-breads-inner">
                    <div className="breadscrumb-inner">
                      <h2 className="bread-title">
                        {CONFIG.DATA.DELETE_USER_PAGE_TITLE}
                      </h2>
                      <ol className="breadcrumb">
                        <li>
                          <a href={CONFIG.DATA.BASEPATH}>Home</a>
                        </li>
                        <li>
                          <span>{CONFIG.DATA.DELETE_USER_PAGE_TITLE}</span>
                        </li>
                      </ol>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        ) : (
          <div className="title-breadcrumb">
            <div className="container">
              <div className="title-breadcrumb-inner">
                <header className="entry-header">
                  <h1 className="entry-title">
                    {CONFIG.DATA.DELETE_USER_PAGE_TITLE}
                  </h1>
                </header>
                <div className="breadcrumbs">
                  <Link to="/">Home</Link>
                  <span className="separator">/</span>
                  <span> {CONFIG.DATA.DELETE_USER_PAGE_TITLE}</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div
        className="deleteuserpageinfo"
        style={{
          color: "#000",
          textAlign: "left",
          padding: "5rem",
          overflow: "hidden",
        }}
        dangerouslySetInnerHTML={{
          __html: CONFIG.DATA.DELETE_USER_PAGE_INFORMATION,
        }}
      ></div>
    </div>
  );
}

export default DeleteAccount;
